"use client";

import { c as _c } from "react/compiler-runtime";
import type { MeasurementAggregationRule, MeasurementBucketGranularity } from "@/lib/measurement-aggregation";
import type { MeasurementDataType, MeasurementGoal, ReferenceRange } from "@/types/measurement";
import MeasurementTrendChartView from "./trend-chart-view";
import { useMeasurementTrendQuery } from "@/query/patient/measurements";
interface MeasurementTrendChartProps {
  patientId: string;
  fieldId: string;
  fieldName: string;
  unit?: string | null;
  color?: string;
  referenceRanges?: ReferenceRange[];
  goal?: MeasurementGoal | null;
  dataType?: MeasurementDataType;
  decimalPlaces?: number | null;
  granularity?: MeasurementBucketGranularity;
  rule?: MeasurementAggregationRule;
}
export default function MeasurementTrendChart(t0) {
  const $ = _c(16);
  const {
    patientId,
    fieldId,
    fieldName,
    unit,
    color,
    referenceRanges,
    goal,
    dataType,
    decimalPlaces,
    granularity,
    rule
  } = t0;
  const {
    data: trendData,
    isLoading,
    isError
  } = useMeasurementTrendQuery(patientId, fieldId);
  let t1;
  if ($[0] !== trendData) {
    t1 = trendData ?? [];
    $[0] = trendData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color || $[3] !== dataType || $[4] !== decimalPlaces || $[5] !== fieldId || $[6] !== fieldName || $[7] !== goal || $[8] !== granularity || $[9] !== isError || $[10] !== isLoading || $[11] !== referenceRanges || $[12] !== rule || $[13] !== t1 || $[14] !== unit) {
    t2 = <MeasurementTrendChartView values={t1} fieldId={fieldId} fieldName={fieldName} unit={unit} color={color} referenceRanges={referenceRanges} goal={goal} dataType={dataType} decimalPlaces={decimalPlaces} granularity={granularity} rule={rule} isLoading={isLoading} isError={isError} />;
    $[2] = color;
    $[3] = dataType;
    $[4] = decimalPlaces;
    $[5] = fieldId;
    $[6] = fieldName;
    $[7] = goal;
    $[8] = granularity;
    $[9] = isError;
    $[10] = isLoading;
    $[11] = referenceRanges;
    $[12] = rule;
    $[13] = t1;
    $[14] = unit;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}